import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Player from "./Player";
import PlayerHome from './PlayerHome';
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import SupportPage from "./pages/SupportPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/play/" replace />} />
        <Route path="/play/" element={<PlayerHome />} />
        <Route path="/play/:gameCode" element={<Player />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/support" element={<SupportPage />} />
      </Routes>
    </BrowserRouter>
  );
}






